<template>
  <div class="brumd_view">
    <div class="brumd_card">
      <span @click="homeBack">首页</span>
      >
      <span v-show="pageTitle0" @click="backToOne">
        {{ pageTitle0 }}
        >
      </span>
      <span @click="backToList">
        {{ pageTitle }}
      </span>

      <span v-show="pageTitle2">
        >
        {{ pageTitle2 }}
      </span>
    </div>
    <!--  -->
    <div class="brumdSearch">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageTitle2: "",
    };
  },
  watch: {
    $route: function () {
      this.pageTitle2 = "详情";
    },
  },
  created() {
    if (this.$route.meta.title) {
      this.pageTitle2 = "详情";
    }
  },
  props: ["pageTitle", "pageTitle0"],
  methods: {
    // 回到首页
    homeBack() {
      const screenWidth = window.screen.width;
      if (screenWidth < 760) {
        this.$router.replace("/phone");
      } else {
        this.$router.replace("/");
      }
    },
    // 回到一级
    backToOne() {
      localStorage.setItem("columnCode", localStorage.getItem("columnCode0"));
      localStorage.setItem("columnName", localStorage.getItem("columnName0"));

      localStorage.removeItem("columnName0");
      localStorage.removeItem("columnCode0");

      this.pageTitle2 = "";
      if (this.$phoneSize()) {
        this.$router.replace({
          name: "phoneEmpty",
        });
      } else {
        this.$router.replace({
          name: "empty",
        });
      }
    },
    // 回到二级
    backToList() {
      this.pageTitle2 = "";
      if (this.$phoneSize()) {
        this.$router.replace({
          name: "phoneEmpty",
        });
      } else {
        this.$router.replace({
          name: "empty",
        });
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .brumd_view {
    border-bottom: 2px solid #f5f5f5;
    display: flex;
    flex-flow: column;
  }
  .brumdSearch{
    padding: 10px 20px;
  }
}
@media screen and (min-width: 750px) {
  .brumd_view {
    border-bottom: 2px solid #f5f5f5;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.brumd_card {
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  padding-left: 20px;
  box-sizing: border-box;
}

.brumd_card span {
  cursor: pointer;
}
</style>
